import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserById, getConnections } from "../api/api";
import "./Messages.css";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";
import pending from "../../assets/images/pending.png";
import verify from "../../assets/images/verified-badges.png";
import userIcon from "../../assets/images/user-icon.png";

const Messages = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [userdata, setUserdata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currUser, setCurrUser] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const loginUser = await loginUserId();
      const connectedUsersRaw = loginUser?.data || [];

      const currentUserRaw = localStorage.getItem("currentUser");
      const parsedCurrentUser = JSON.parse(currentUserRaw);
      const currentUserId = parsedCurrentUser?.id || parsedCurrentUser?._id;
      setCurrUser(parsedCurrentUser);

      const filteredUsers = connectedUsersRaw
        .filter((conn) => conn.status === "1" && conn.unfriended === "0")
        .map((conn) => {
          if (conn.from_user?.id === currentUserId) {
            return conn.to_user;
          } else if (conn.to_user?.id === currentUserId) {
            return conn.from_user;
          }
          return null;
        })
        .filter(Boolean);

      setUserdata(filteredUsers);
    } catch (error) {
      console.error("Error in fetchData:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loginUserId = async () => {
    try {
      const loginuserData = localStorage.getItem("currentUser");
      const loginparsedUserData = JSON.parse(loginuserData);
      const logincurrentUserId =
        loginparsedUserData?.id || loginparsedUserData?._id;

      if (logincurrentUserId) {
        const getchatUser = await getConnections({
          user_id: logincurrentUserId,
        });
        return getchatUser;
      }
    } catch (error) {
      console.error("Error fetching login user data:", error);
    }
  };

  const handleClick = async (id) => {
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const currentUserId = parsedUserData?.id || parsedUserData?._id;

      const chuser = await getUserById({ user_id: id });
      const user = await getUserById({ user_id: currentUserId });

      if (user?.data?.plan_payment_status === "1") {
        if (chuser?.data?.approve_reject_new_image === "pending") {
          Swal.fire({
            icon: "info",
            title: "Pending Profile",
            text: "This user profile is still pending. Please try again later.",
          });
        } else if (chuser?.data?.plan_payment_status === "1") {
          navigate(`/Sidebar/chat/${id}`);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Chat Not Available",
            text: "The user you are trying to chat with has not completed the payment yet.",
          });
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Payment Required",
          text: "Please complete your payment to start chatting.",
        }).then(() => {
          navigate(`/Sidebar/ConnectionPayment/${id}`);
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong. Please try again.",
      });
    }
  };

  const filteredData = userdata?.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="messages-container">
      <div className="messages-card">
        <div className="messages-header">Messages</div>
        {/* <div className="messages-input">
          <input
            type="text"
            placeholder="Search Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div> */}

        {isLoading ? (
          <div className="loading-spinner">Loading...</div>
        ) : filteredData?.length > 0 ? (
          filteredData?.map((user) => (
            <div
              key={user?.id || user?._id}
              className="message-item"
              onClick={() => handleClick(user?.id || user?._id)}
            >
              <img
                src={
                  user?.pre_consent_for_displaying_images === true &&
                  user?.more_images?.length
                    ? `${environment.url}/uploads/users/${user?.more_images[0]}`
                    : userIcon
                }
                alt="Avatar"
                className="avatar"
              />

              <div className="message-info">
                <h3>{user?.name}</h3>
                {user?.approve_reject_new_image === "pending" ? (
                  <img
                    src={pending}
                    alt="Pending"
                    className="message-status-icon"
                  />
                ) : (
                  <img
                    src={verify}
                    alt="Verified"
                    className="message-status-icon"
                  />
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="nouserfoundText">No connected user found.</p>
        )}
      </div>
    </div>
  );
};

export default Messages;
